export default __webpack_public_path__ + "static/Events-e35fda7d74e9b0db0a2e255151985b70.jpg";